"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeConfigs = exports.colorFactory = void 0;
var color_factory_1 = require("./color-factory");
Object.defineProperty(exports, "colorFactory", { enumerable: true, get: function () { return color_factory_1.colorFactory; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "mergeConfigs", { enumerable: true, get: function () { return utils_1.mergeConfigs; } });
